import { FEATURES, FEATURES_2 } from "./PricingSection.data";
import { Marquee } from "./pricing/Marquee";
import { PricingTiers } from "./pricing/PricingTiers";
import { RiskReversalCard } from "./pricing/RiskReversalCard";
import { TestimonialFeatureSectionFour } from "./TestimonialFeatureSectionFour";



interface PricingSectionProps {
  onCtaClick?: () => void;
}

export function PricingSection({ onCtaClick }: PricingSectionProps) {
  return (
    <section id="pricing" className="relative isolate overflow-hidden bg-background pt-4 pb-0 sm:pt-6">
      <div className="mx-auto max-w-6xl px-6">
        <div className="text-center mb-20 sm:mb-24">
          <h3 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl lg:text-5xl">
            Pick a plan that's{" "}
            <span className="text-gradient-cycle">right for you</span>
          </h3>
          <p className="mt-4 text-base md:text-lg text-muted-foreground mx-auto sm:whitespace-nowrap">
            Three ways to launch. One that fits how you want to pay. Every plan includes a free mockup before you commit.
          </p>
        </div>


        <div id="pricing-web-design" className="scroll-mt-24">
          <PricingTiers />
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-6">
        <RiskReversalCard onCtaClick={onCtaClick} />
      </div>

      <div className="mx-auto max-w-6xl px-6">
        <div className="mt-10 sm:mt-12">
          <Marquee items={FEATURES} variant="blue" />
        </div>
        <div className="mt-4 mb-0">
          <Marquee items={FEATURES_2} variant="pink" reverse />
        </div>
      </div>

      <TestimonialFeatureSectionFour />

    </section>
  );
}
